import { observable } from 'mobx';

import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';

import { FlightsIconPlacard } from '__generated__/api';

export class BannersStore extends Store {
  @observable public banners: FlightsIconPlacard.Fragment[];
  @observable public refreshBanner: boolean | false;
  public isDialogEvent = false;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public setIsDialogEvent(dialogEvent: boolean) {
    this.isDialogEvent = dialogEvent;
  }
}
